// extracted by mini-css-extract-plugin
export default {"root":"user-details_root__GnZnl","open":"user-details_open__jx3Qw","header":"user-details_header__p+DWo","close":"user-details_close__yC1Dg","title":"user-details_title__0B0P4"};